<template>
  <div
    :style="pageParams.boxStyle"
    class="box-field"
  >
    <div
      :style="pageParams.inputBoxStyle"
      class="input-box"
    >
    <!-- @paste="preventPaste"
        @copy="preventCopy"
        @cut="preventCut" -->
        <!-- @input="onInputChange" -->
      <input
        type="text"
        :style="pageParams.inputStyle"
        class="input-field"
        v-model="userInput"
        @paste="preventPaste"
        @copy="preventCopy"
        @cut="preventCut" 
        @contextmenu="preventContextMenu"
        placeholder="請輸入卡號..."
        required
        :disabled="required"
        maxlength="19"
      >
      <span
        :style="pageParams.spanStyle"
        class="span-field"
      >{{ mes }} </span>
    </div>
    <button
      :style="pageParams.buttonStyle"
      type="button"
      class="button-field"
      @click="clearForm"
    >清空</button>
  </div>
</template>
<script>
  import axios from 'axios'
  import CryptoJS from 'crypto-js'
  import securityConfig from '@/config/security.config.js'

  export default {
    name: 'TokenForm',
    data() {
      return {
        userInput: '',
        loading: false,
        result: '',
        pageParams: {
          id: '',
          boxStyle: '',
          inputBoxStyle: '',
          inputStyle: "",
          buttonStyle: '',
          spanStyle: "",
          accessToken: '',
        },
        websocket: null,
        isConnected: false,
        mes: '',
        appId: "APP2025871274",
        appSecret: "0b7967f6067fed672f6e6d1c6f679939",
        kek: "ae91070d174756a5c4093611fdb2e11b",
        accessToken: '',
        required: false,
        // 安全配置：允許的父頁面域名白名單（從配置文件導入）
        allowedParentOrigins: securityConfig.allowedParentOrigins,
        securityConfig: securityConfig, // 保存完整配置供使用
      }
    },
    mounted() {
      this.initPage()
      // this.initSecureMessageListener()
      // this.intToken()
      // this.initWebSocket()
    },
    watch: {
      userInput: {
        handler(newVal) {
          // console.log('newVal', newVal)
          // 获取输入值并移除所有非数字字符
          let value = newVal.replace(/\D/g, '')
          // console.log('value', value.length, value)
          // 限制最多19位数字（支持13/15/16/19位卡号）
          if (value.length > 19) {
            value = value.substring(0, 19)
          }

          // 每4位数字添加一个空格
          let formattedValue = value.replace(/(\d{4})(?=\d)/g, '$1 ')

          // 更新输入框的值
          this.userInput = formattedValue
          // console.log(value.length === 16,value.length)
          if(value.length === 16){
            setTimeout(() => {
              // 此时界面已经显示完整
              this.onchange(value)
            }, 50);
            
          }
        },
        immediate: true
      }
    },
    beforeUnmount() {
      // this.closeWebSocket()
      // this.removeSecureMessageListener()
    },
    methods: {
      /**
     * 验证银行卡号是否有效（基于Luhn算法）
     * @param {string} cardNumber - 银行卡号（可以包含空格或连字符）
     * @returns {boolean} - 有效返回true，无效返回false
     */
      isValidBankCardNumber(cardNumber) {
        // 1. 清除卡号中的非数字字符
        const cleaned = cardNumber.replace(/\D/g, '');
        // 2. 检查卡号长度是否合法（通常13-19位）
        // if (cleaned.length < 13 || cleaned.length > 19) {
        //     return false;
        // }
        if (cleaned.length !== 16) {
          return false;
        }
        // 3. 执行Luhn算法
        let sum = 0;
        let isSecond = false;

        // 从右向左遍历每一位数字
        for (let i = cleaned.length - 1; i >= 0; i--) {
          let digit = parseInt(cleaned.charAt(i), 10);

          // 偶数位（从右数第二位开始）乘以2
          if (isSecond) {
            digit *= 2;
            // 若乘以2后大于9，则减去9（等价于取各位之和）
            if (digit > 9) {
              digit -= 9;
            }
          }

          // 累加所有结果
          sum += digit;
          // 切换奇偶位标识
          isSecond = !isSecond;
        }

        // 4. 检查总和是否能被10整除
        return (sum % 10 === 0);
      },

      async intToken() {
        let sign = this.generateSign()
        // const timestamp = Date.now()  prod-api
        const response = await axios.post('/prod-api/access/token', {}, {
          headers: {
            sign: sign.sign,
            appId: this.appId,
            reqTime: sign.timestamp
          }
        })
        if (response.data.code === 0) {
          this.accessToken = response.data.data.accessToken
        }
      },
      // 生成簽名
      generateSign(bodyData) {
        const keyBytes = CryptoJS.enc.Utf8.parse(this.appSecret);
        const timestamp = Date.now()
        let plaintext = ''
        if (JSON.stringify(bodyData)) {
          plaintext = this.appId + timestamp + JSON.stringify(bodyData)
          // console.log('plaintext', plaintext)
        } else {
          plaintext = this.appId + timestamp
        }
        // console.log('plaintext2', plaintext)
        const encrypted = CryptoJS.AES.encrypt(plaintext, keyBytes, {
          mode: CryptoJS.mode.ECB,
          padding: CryptoJS.pad.Pkcs7  // PKCS7等同於PKCS5
        })
        // console.log('AES加密', encrypted.toString())
        const sign = CryptoJS.MD5(encrypted.toString()).toString()
        // console.log('signMD5', sign)
        return {
          sign: sign,
          timestamp: timestamp
        }
      },
      generateRandomKey() {
        const array = new Uint8Array(16); // 16字节 = 128位
        window.crypto.getRandomValues(array); // 获取随机值

        // 将字节数组转换为十六进制字符串
        const hexKey = Array.from(array, byte => byte.toString(16).padStart(2, '0')).join('');
        return hexKey;
      },
      generateRandom6Key(length = 6) {
        const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'; // 你也可以加入字母：'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
        let result = '';
        for (let i = 0; i < length; i++) {
          result += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return result;
      },
      // 处理输入格式化
      onInputChange(val) {
        

        // 使用 nextTick 延迟执行，让输入框先完成渲染更新
        this.$nextTick(() => {
          // 调用原有的onchange逻辑，但使用纯数字
          this.onchange(val)
        })
      },

      // 监听卡号提交
      async onchange(pureNumber) {

        if (!this.isValidBankCardNumber(pureNumber)) {
          // alert('请输入有效的银行卡号');
          // console.log('请输入有效的银行卡号')
          this.mes = '請輸入有效的銀行卡號'
          return
        }
        // console.log('pureNumber', pureNumber.length,pureNumber)
        if (pureNumber && pureNumber.length === 16) {

          const randomKey = this.generateRandomKey()
          const random6Digits = this.generateRandom6Key()
          const saltNub = CryptoJS.enc.Utf8.parse(random6Digits)
          // 生成簽名

          // AES256加密param01: 卡號+123456
          const param01Encrypted = this.aes256Encrypt(pureNumber, randomKey, saltNub)
          // AES256加密param02: param01的密文+123456
          const param02Encrypted = this.aes256Encrypt(randomKey, this.kek, saltNub)

          // 準備WebSocket消息數據
          const messageData = {
            activityNo: this.pageParams.id,
            param01: param01Encrypted,
            param02: param02Encrypted,
            salt: random6Digits,
          }
          const signData = this.generateSign(messageData)
          this.required = true
          const response = await axios.post('/prod-api/activity/submit', messageData, {
            headers: {
              appId: this.appId,
              reqTime: signData.timestamp.toString(),
              sign: signData.sign,
              accessToken: this.pageParams.accessToken,
            }
          })
          // console.log('response', response)
          // const errorMessages = {
          //   3101: "缺少參數,請檢查appId、reqTime、sign",
          //   3401: "簽名不合法，請求被拒絕，請檢查簽名規則",
          //   3402: "reqTime不合法,需要毫秒級時間戳",
          //   3501: "當前accessToken已過期,請重刷新重新申請",
          //   3502: "請求被拒絕,accessToken不存在或不合法",
          //   3701: "當前卡號無效,卡號不在卡bin範圍內",
          //   3702: "解密失敗,請檢查PAN、DEK加密算法及密鑰",
          //   3703: "當前卡號已生成Token並處於活躍中",
          //   3704: "當前卡號不是JCB卡"
          // };
          let errorMessages = {};
          if(this.appId == 'APP2025823784'){
            errorMessages = {
             3101: "缺少參數,請檢查appId、reqTime、sign",
             3401: "簽名不合法，請求被拒絕，請檢查簽名規則",
             3402: "reqTime不合法,需要毫秒級時間戳",
             3501: "當前accessToken已過期,請重刷新重新申請",
             3502: "請求被拒絕,accessToken不存在或不合法",
             3701: "請輸入有效卡號",
             3702: "請輸入有效卡號",
             3703: "請輸入有效卡號",
             3704: "請輸入有效卡號"
            };
          }
          else{
            errorMessages = {
              3101: "缺少參數,請檢查appId、reqTime、sign",
              3401: "簽名不合法，請求被拒絕，請檢查簽名規則",
              3402: "reqTime不合法,需要毫秒級時間戳",
              3501: "當前accessToken已過期,請重刷新重新申請",
              3502: "請求被拒絕,accessToken不存在或不合法",
              3701: "當前卡號無效,卡號不在卡bin範圍內",
              3702: "解密失敗,請檢查PAN、DEK加密算法及密鑰",
              3703: "當前卡號已生成Token並處於活躍中",
              3704: "當前卡號不是JCB卡"
            };
          }
          let listpro = {}
          if (errorMessages.hasOwnProperty(response.data.code)) {
            this.mes = errorMessages[response.data.code];
            listpro = {
              status: false,
              code: response.data.data.code,
              pan: response.data.data.pan,
              issName: response.data.data.name,
              statusCode: response.data.data.code
            }
            this.required = false;
            this.sendMessageToParent(listpro)
          }
          if (response.data.code == 0) {
            // code：安全碼、pan：前6後4、issName：卡組、status:ture
            listpro = {
              status: true,
              code: response.data.data.code,
              pan: response.data.data.pan,
              issName: response.data.data.name
            }
            this.mes = response.data.data.name,
              this.sendMessageToParent(listpro)
          }
        } else {
          this.required = false
        }
      },
      // 獲取URL參數
      getUrlParams() {
        const urlParams = new URLSearchParams(window.location.search)
        // console.log('initPage', !urlParams.get('accessToken'))
        if (!urlParams.get('accessToken')) {
          alert('accessToken不存在')
          this.mes = "accessToken不存在"
          // 即使沒有 accessToken，也要返回默認對象，避免 pageParams 為 undefined
        }
        return {
          id: urlParams.get('id') || '123456',
          boxStyle: urlParams.get('boxStyle') || '',
          inputBoxStyle: urlParams.get('inputBoxStyle') || '',
          inputStyle: urlParams.get('inputStyle') || '',
          spanStyle: urlParams.get('spanStyle') || '',
          buttonStyle: urlParams.get('buttonStyle') || "",
          accessToken: urlParams.get('accessToken') || '',
          appId: urlParams.get('appId') || this.appId,
        }
      },

      // 初始化頁面
      initPage() {

        this.pageParams = this.getUrlParams()
        // console.log('this.pageParams', this.pageParams)
      },

      // AES256加密 - 完全匹配後端Java實現
      aes256Encrypt(text, password, salt) {
        // 1. 固定鹽值 "123456" (匹配後端getSalt方法)
        // console.log('salt', salt)
        // console.log('password', password)
        // console.log('text', text)

        // 2. 使用PBKDF2派生密鑰 (匹配後端generateKey方法)
        // Java: PBKDF2WithHmacSHA256, 迭代65536次, 256位密鑰
        const key = CryptoJS.PBKDF2(password, salt, {
          keySize: 256 / 32,  // 256位密鑰 = 32字節
          iterations: 65536,  // 迭代次數65536
          hasher: CryptoJS.algo.SHA256  // PBKDF2WithHmacSHA256
        })

        // 3. 生成隨機IV (16字節，匹配後端)
        const iv = CryptoJS.lib.WordArray.random(16)

        // 4. AES/CBC/PKCS5Padding加密 (匹配後端ALGORITHM)
        const encrypted = CryptoJS.AES.encrypt(text, key, {
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7  // PKCS7等同於PKCS5
        })

        // 5. 組合結果：iv + encrypted (匹配後端combined數組)
        const result = iv.concat(encrypted.ciphertext)

        // console.log('AES256加密完成:', result.toString(CryptoJS.enc.Base64))

        return result.toString(CryptoJS.enc.Base64)
      },
      // 向父頁面發送消息
      sendMessageToParent(data) {
        if (window.parent && window.parent !== window) {
          window.parent.postMessage(data, '*')
          // console.log('window.postMessage')
        }
      },
      // 向父頁面發送消息（安全版本）
      // sendMessageToParent(data) {
      //   if (window.parent && window.parent !== window) {
      //     // 安全措施1: 只向白名單中的域名發送消息
      //     this.allowedParentOrigins.forEach(origin => {
      //       try {
      //         // 添加時間戳和簽名防止數據被篡改
      //         const secureData = {
      //           type: 'TOKEN_RESPONSE',
      //           timestamp: Date.now(),
      //           payload: data,
      //           // 可選：添加簽名驗證
      //           signature: this.securityConfig.enableSignatureVerification 
      //             ? this.generateMessageSignature(data) 
      //             : null
      //         }
      //         window.parent.postMessage(secureData, origin)

      //         // 開發環境顯示日誌
      //         if (this.securityConfig.enableSecurityLogs) {
      //           console.log('✓ 安全消息已發送到:', origin)
      //           console.log('  - 數據類型:', secureData.type)
      //           console.log('  - 時間戳:', new Date(secureData.timestamp).toLocaleString())
      //           console.log('  - 簽名:', secureData.signature ? secureData.signature.substring(0, 16) + '...' : '未啟用')
      //         }
      //       } catch (error) {
      //         console.warn('發送消息失敗:', origin, error)
      //       }
      //     })
      //   }
      // },

      // 生成消息簽名（防止數據被篡改）
      generateMessageSignature(data) {
        const message = JSON.stringify(data) + this.appSecret
        return CryptoJS.MD5(message).toString()
      },

      // 驗證父窗口的域名（可選，用於接收父窗口消息時）
      isValidParentOrigin(origin) {
        return this.allowedParentOrigins.includes(origin)
      },

      // 清空表單
      clearForm() {
        this.userInput = ''
        this.mes = ''
        this.required = false
        let listpro = {

          emptyType: true, //1:清空 2:失敗
        }
        // this.mes = response.data.data.name,
        this.sendMessageToParent(listpro)
      },

      // 初始化安全消息監聽器
      initSecureMessageListener() {
        this.messageHandler = (event) => {
          // 安全措施2: 驗證消息來源
          if (!this.isValidParentOrigin(event.origin)) {
            if (this.securityConfig.enableSecurityLogs) {
              console.warn('⚠️ 拒絕來自未授權域名的消息:', event.origin)
              console.warn('  允許的域名:', this.allowedParentOrigins)
            }
            return
          }

          // 如果父頁面需要發送配置消息給iframe，可以在這裡處理
          if (event.data && event.data.type === 'CONFIG_UPDATE') {
            if (this.securityConfig.enableSecurityLogs) {
              console.log('✓ 接收到配置更新:', event.data)
            }
            // 可以更新樣式配置，但絕不暴露敏感數據
            // 示例：更新主題色等非敏感配置
          }
        }
        window.addEventListener('message', this.messageHandler)

        if (this.securityConfig.enableSecurityLogs) {
          console.log('🔒 安全消息監聽器已初始化')
          console.log('  允許的父頁面域名:', this.allowedParentOrigins)
        }
      },

      // 移除消息監聽器
      removeSecureMessageListener() {
        if (this.messageHandler) {
          window.removeEventListener('message', this.messageHandler)
        }
      },

      // 防止粘贴
      preventPaste(event) {
        event.preventDefault()
        return false
      },

      // 防止复制
      preventCopy(event) {
        event.preventDefault()
        return false
      },

      // 防止剪切
      preventCut(event) {
        event.preventDefault()
        return false
      },

      // 防止右键菜单
      preventContextMenu(event) {
        event.preventDefault()
        return false
      },

    },
    created() {

    }
  }
</script>
<style scoped>
  .box-field {
    display: flex;
  }

  .input-box {
    flex: 4;
  }

  .input-field {
    width: 100%;
    height: 46px;
    padding-left: 10px;
    border-radius: 6px;
    flex: 4;
    font-size: 15px;
    /* 防止选择和复制 */
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    /* 防止拖拽 */
    -webkit-user-drag: none;
    -khtml-user-drag: none;
    -moz-user-drag: none;
    -o-user-drag: none;
  }

  .span-field {
    padding-left: 20px;
    color: red;
    flex: 1;
    font-size: 15px;
  }

  .button-field {
    background: rgb(108, 117, 125);
    color: white;
    flex: 1 1 0%;
    height: 46px;
    margin-left: 20px;
    border-radius: 6px;
    border: none;
    cursor: pointer;
    transition: all 0.3s ease;
  }

</style>
